import { useMemo, useState } from 'react'
import { useKeenSlider } from 'keen-slider/react'
import { GalleryItem } from '@/types/models'
import { GalleryVariantProps, gallery } from './gallery.variants'

export type useGalleryProps = GalleryVariantProps & {
  className?: string
  title?: string
  data: {
    id: string | number
    title: string | null
    image: string
  }[]
}

export const useGallery = (props: useGalleryProps) => {
  const { className = '', title, data = [] } = props

  const [currentSlide, setCurrentSlide] = useState(0)
  const [loaded, setLoaded] = useState(false)

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    slides: {
      spacing: 80
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    created() {
      setLoaded(true)
    }
  })

  const styles = useMemo(() => gallery(), [])

  return {
    className,
    styles,
    sliderRef,
    instanceRef,
    loaded,
    currentSlide,
    title,
    data
  }
}
